/* =========================================================================
 * Kkumi · Wishlist Bus
 * Tiny shared pub/sub so the wishlist sections (grid, toolbar, hero, share,
 * recommendations) can coordinate on the same page. The grid registers a
 * controller via setGrid(); sections listen for 'ready' / 'change'. It also
 * tracks "shared (read-only) view" mode (?shared={publicId}) and the resolved
 * owner name / items via setShared(). Guarded so multiple includes are safe.
 * ========================================================================= */
window.KkwlBus = window.KkwlBus || (function () {
  var listeners = {};
  var bus = {
    grid: null,
    sharedId: (function () { try { return new URLSearchParams(window.location.search).get('shared'); } catch (e) { return null; } })(),
    sharedName: null,
    sharedItems: null,
    search: null,        // set by the grid: search(query, keywords) — see kkumi-wishlist-grid.js
    pendingSearch: null, // a search requested before the grid registered (?q= deep link)
    offersUndo: false,   // set by a section with an Undo toast (the account tab): the grid holds removals for it
                         // and its 'removed' events carry undo() / commit() — see kkumi-account-wishlist.js
    on: function (ev, cb) {
      (listeners[ev] = listeners[ev] || []).push(cb);
      // Replay current state to late subscribers (handles load-order).
      if (ev === 'ready' && bus.grid) { try { cb(bus.grid); } catch (e) {} }
      if (ev === 'change' && bus.grid && bus.grid.state) { try { cb(bus.grid.state()); } catch (e) {} }
      if (ev === 'shared' && bus.sharedName != null) { try { cb({ id: bus.sharedId, name: bus.sharedName, items: bus.sharedItems }); } catch (e) {} }
      return bus;
    },
    emit: function (ev, data) {
      (listeners[ev] || []).forEach(function (cb) { try { cb(data); } catch (e) {} });
      return bus;
    },
    setGrid: function (g) {
      bus.grid = g;
      bus.emit('ready', g);
      if (g && g.state) bus.emit('change', g.state());
      return bus;
    },
    setShared: function (name, items) {
      bus.sharedName = name || '';
      bus.sharedItems = items || [];
      bus.emit('shared', { id: bus.sharedId, name: bus.sharedName, items: bus.sharedItems });
      return bus;
    }
  };
  return bus;
})();
